import { Colors } from '@constants/colors.constants';
import { Button, InputLabel, Stack, alpha } from '@mui/material';

interface AuditsToggleButtonProps {
  label: string;
  labelWidth?: number;
  isActive: boolean;
  required?: boolean;
  handleToggle: (isActive: boolean) => void;
}

const AuditsToggleButton = (props: AuditsToggleButtonProps) => {
  const { label, labelWidth, isActive, required, handleToggle } = props;

  const colors = isActive ? Colors.text : Colors.white;
  const colorsRevert = isActive ? Colors.white : Colors.text;

  return (
    <Stack direction={'row'} alignItems={'center'} spacing={1}>
      {!!label && (
        <InputLabel sx={{ width: labelWidth ? `${labelWidth}px` : undefined }}>
          {
            label + (required ? '*' : '')}
        </InputLabel>
      )}
      <Stack direction='row' spacing={2} alignItems='center'>
        <Button onClick={() => handleToggle(true)} sx={{ backgroundColor: colors, color: colorsRevert, ':hover': { backgroundColor: alpha(colors, 0.7) } }}>
          Activer
        </Button>
        <Button onClick={() => handleToggle(false)} sx={{ backgroundColor: colorsRevert, color: colors, ':hover': { backgroundColor: alpha(colorsRevert, 0.7) } }}>
          Désactiver
        </Button>
      </Stack>
    </Stack>
  );
};

export default AuditsToggleButton;